// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c940d221","239":"4fe5cd75","455":"04a27f23"}[chunkId] + ".chunk.js";
};